const areArgsEqual = (newArgs: any[], prevArgs: any[]) => {
    return (
        newArgs.length === prevArgs.length &&
        newArgs.every((arg, index) => {
            return arg === prevArgs[index];
        })
    );
};

export function memoizeOne<T extends Function>(originalFunc: T): T {
    let lastArgs: any[];
    let lastResult: T;
    let lastThis: any;
    const memoized = function (...args: any[]) {
        if (lastArgs && lastThis === this && areArgsEqual(args, lastArgs)) {
            return lastResult;
        }

        lastResult = originalFunc.apply(this, args);
        lastArgs = args;
        lastThis = this;
        return lastResult;
    };

    return <T>(<any>memoized);
}
